export const govern_data=[
    {
        'sno':'1',
        'name':'Er.A.Andrew,\nGeneral Manager,\nBHEL,\nThirumayam.',
        'desi':'Chairman',
        'tenure':''
    },
    {
        'sno':'2',
        'name':'Dr.S.Jayanthi,\nAdditional Director DOTE,\nChennai.',
        'desi':'DOTE Nominee',
        'tenure':''
    },
    {
        'sno':'3',
        'name':'Dr.B.RameshBabu,\nChief Scientist,\nCSIR-CECRI,\nKaraikudi.',
        'desi':'Professionalist',
        'tenure':''
    },
    {
        'sno':'4',
        'name':'Dr.K.Baskaran,\nProfessor and Head/Department of Electrical and Electronics Engineering,\nACGCET,\nKaraikudi.',
        'desi':'Senior Professor of the Institution',
        'tenure':''
    },
    {
        'sno':'5',
        'name':'Dr.P.K.Palani,\nPrincipal,\nACGCET,\nKaraikudi.',
        'desi':'Member/Secretary',
        'tenure':''
    },
    {
        'sno':'6',
        'name':'Dr.A.Sivanantharaja,\nProfessor and Head/Department of Electronics and Communication Engineering,\nACGCET,\nKaraikudi.',
        'desi':'Senior Professor of the Institution',
        'tenure':''
    },
    {
        'sno':'7',
        'name':'Dr.Lima Rose Miranda,\nProfessor,\nDepartment of Chemical Engineering,\nACT Campus,\nAnna University,\nChennai.',
        'desi':'Anna University Nominee',
        'tenure':''
    },
    {
        'sno':'8',
        'name':'Dr.G.Kumaresan,\nAssociate Professor and Deputy Director,\nCentre for Research,\nInstitute of Energy Studies,\nDepartment of Mechanical Engineering,\nCEG,\nAnna University,\nChennai.',
        'desi':'Professionalist',
        'tenure':''
    },
    {
        'sno':'9',
        'name':'Thiru.G.Venkatesan,\nDeputy Secretary to Government and FA& CAO,\nDOTE,\nChennai.',
        'desi':'Government Nominee',
        'tenure':''
    }
]